import { type QuickSearchFilters } from '@/scopes/search/quick-search/domain/types';
import { identity, isEmpty } from 'ramda';
import { createRoomsParticipantDistributionMapper } from '@/scopes/search/search/infrastructure/api/filtersSelectionMapper/mappers/roomsParticipantDistributionMapper';
import type { RoomOccupancy } from '@/domain/shared/types';

interface Dependencies {
  roomsParticipantDistributionMapper: ReturnType<typeof createRoomsParticipantDistributionMapper>;
}

const defaultParticipants: RoomOccupancy[] = [
  {
    adults: 2,
    children: [],
    babies: [],
  },
];

export const createQuickSearchFiltersParser = (dependencies: Partial<Dependencies> = {}) => {
  const { roomsParticipantDistributionMapper = createRoomsParticipantDistributionMapper() } = dependencies;

  function serialize({ Participants, Destination, ...rest }: QuickSearchFilters) {
    return {
      ...rest,
      Participants:
        Participants && !isEmpty(Participants)
          ? roomsParticipantDistributionMapper(Participants ?? [])
          : roomsParticipantDistributionMapper(defaultParticipants),
      ...(Destination ? { Destination: Destination.value } : {}),
    };
  }

  return { serialize, parse: identity };
};
